import { customrOption } from "@BZA/Account/Customer/customerOption";
import { ISearchBoxProps } from "@fluentui/react/lib/SearchBox";
import { IsIsNullOrEmpty, getLocalStorage } from "./common";

export const cidSeachBox = (
  setCustomerList: any,
  setSearchValue: any,
  t: (key: string) => string
): ISearchBoxProps => {
  const cidSeachBoxProps: ISearchBoxProps = {
    placeholder: t("Basics.Search"),
    styles: {
      root: {
        width: 305,
      },
    },
    clearButtonProps: { iconProps: { iconName: "Clear" } },
    onEscape: (ev: any) => {
      console.log("Custom onEscape Called");
    },
    onClear: (ev: any) => {
      setCustomerList([...customrOption.getCustomers().customers]);
    },
    // onChange: (_: any, newValue: string) => console.log("SearchBox onChange fired: " + newValue),
    onSearch: (newValue: any) => {
      setSearchValue(newValue);
      if (IsIsNullOrEmpty(newValue)) {
        setCustomerList([...customrOption.getCustomers(newValue).customers]);
      } else {
        setCustomerList([...customrOption.getCustomers(newValue)]);
      }
    },
  };
  return cidSeachBoxProps;
};

export const headerAIDSeachBoxProps = (
  setAccounts: any,
  searchValue: any,
  t: (key: string) => string
): ISearchBoxProps => {
  const aidSearchBox: ISearchBoxProps = {
    placeholder: t("ReportData.searchPlaceholders.searchAccount"),
    styles: {
      root: {
        width: 352,
        margin: "16px 24px",
      },
    },
    clearButtonProps: { iconProps: { iconName: "Clear" } },
    onEscape: (ev) => {
      console.log("Custom onEscape Called");
    },
    onClear: (ev) => {
      searchValue("");
      setAccounts([...customrOption.getAccount("").accounts]);
    },
    onChange: (_, newValue) => {
      searchValue(newValue);
      if (IsIsNullOrEmpty(newValue)) {
        setAccounts([...customrOption.getAccount(newValue).accounts]);
      } else {
        setAccounts([...customrOption.getAccount(newValue)]);
      }
    },
    onSearch: (newValue: string) => {
      searchValue(newValue);
      if (IsIsNullOrEmpty(newValue)) {
        setAccounts([...customrOption.getAccount(newValue).accounts]);
      } else {
        setAccounts([...customrOption.getAccount(newValue)]);
      }
    },
  };
  return aidSearchBox;
};

export const CIDSeachBoxProps = (
  setCustomerList: any,
  setSearchValue: any,
  t: (key: string) => string
): ISearchBoxProps => {
  const cidSearchBox: ISearchBoxProps = {
    placeholder: t("Basics.Search"),
    clearButtonProps: { iconProps: { iconName: "Clear" } },
    styles: {
      root: {
        height: 32,
        lineHeight: 32,
      },
      icon: {
        alignItems: "center"
      },
      field: {
        height: 32,
        lineHeight: 32
      }
    },
    onEscape: (ev) => {
      console.log("Custom onEscape Called");
    },
    onClear: (ev) => {
      setCustomerList([...customrOption.getCustomers().customers]);
    },
    onChange: (_, newValue) => {
      setSearchValue(newValue);
      if (IsIsNullOrEmpty(newValue)) {
        setCustomerList([...customrOption.getCustomers(newValue).customers]);
      } else {
        setCustomerList([...customrOption.getCustomers(newValue)]);
      }
    },
    onSearch: (newValue: string) => {
      setSearchValue(newValue);
      if (IsIsNullOrEmpty(newValue)) {
        setCustomerList([...customrOption.getCustomers(newValue).customers]);
      } else {
        setCustomerList([...customrOption.getCustomers(newValue)]);
      }
    },
  };
  return cidSearchBox;
};

export const CampaignCennter = (setCampaignList: any, t: (key: string) => string): ISearchBoxProps => {
  const cidSearchBox: ISearchBoxProps = {
    styles: {
      root: { width: 200 },
    },
    placeholder: t("Material.searchAssetsName"),
    clearButtonProps: { iconProps: { iconName: "Clear" } },
    onEscape: (ev) => {
      console.log("Custom onEscape Called");
    },
    onClear: (ev) => {
      setCampaignList("");
    },
    onChange: (_, newValue) =>
      console.log("SearchBox onChange fired: " + newValue),
    onSearch: (newValue: string) => {
      setCampaignList(newValue);
    },
  };
  return cidSearchBox;
};
